import { format } from 'date-fns';

export const formatContentDate = (value?: string | null): string =>
  value ? format(new Date(value), 'MMM d, yyyy') : '/';

export const formatContentDateTime = (value?: string | null): string =>
  value ? format(new Date(value), 'MMM d, yyyy, h:mm a') : '/';
